// extracted by mini-css-extract-plugin
export default {"card":"d7-z"};